export default __webpack_public_path__ + "static/media/Blooded Belt of the Mound.c829b07e.jpg";